import React, { useEffect } from 'react';
import AppRoutes from './routing/AppRoutes';
import { loadUser } from './Redux/actions/authAction';
import setAuthToken from './utils/setAuthToken';

// Redux
import { Provider } from 'react-redux';
import store from './store';

import './App.css';

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
};

export default App;
